/**
 * @flow
 */
import routes from 'routes/scheduling'

const Scheduling = () => routes

export default Scheduling
